import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {Shipment} from '../services/shipment';
import {ShipmentRoute} from '../services/shipment-route';
import {ShipmentsService} from '../services/shipments.service';
import {Lightbox} from 'ngx-lightbox';
import {ShipmentEvent} from '../services/shipment-event';
import {DomSanitizer} from '@angular/platform-browser';
import * as moment from 'moment';
import 'moment/locale/da';
import {ShipmentEditModalComponent} from '../shipment-edit-modal/shipment-edit-modal.component';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../environments/environment';
import {ShipmentEventModalComponent} from '../shipment-event-modal/shipment-event-modal.component';
import {ShipmentPackageAddModalComponent} from '../shipment-package-add-modal/shipment-package-add-modal.component';
import {EventForwardModalComponent} from '../event-forward-modal/event-forward-modal.component';
import {faDollarSign, faMobile, faMobileAlt, faPhoneAlt, faShare, faTrash} from '@fortawesome/free-solid-svg-icons';
import {ShipmentProductLineModalComponent} from '../shipment-product-line-modal/shipment-event-modal.component';
import {ShipmentProductLine} from '../services/shipment-product-line';
import {ShipmentService} from '../services/shipment-service';
import {ShipmentPackagesService} from '../services/shipment-packages.service';
import {mergeMap, catchError, of, combineLatest, from, tap, finalize, Observable} from 'rxjs';
import {ShipmentAddressPickerComponent} from "../shipment-address-picker/shipment-address-picker.component";
import {ActivatedRoute, Router} from "@angular/router";
import {UsersService} from "@hassel-it/angular-common";

@Component({
    selector: 'app-shipment-edit-form',
    templateUrl: './shipment-edit-form.component.html',
    styleUrls: ['./shipment-edit-form.component.scss'],
    providers: [ShipmentPackagesService]
})
class ShipmentEditFormComponent implements OnInit, OnChanges {

    @Input() parentModal!: NgbModalRef;
    @Input() public _shipment: Shipment;
    @Input() public shipmentRoutes: ShipmentRoute[];
    @Input() public simple: boolean;
    @Output() stuffChanged = new EventEmitter<any>();

    isReturn = false;
    album;
    imageBase64;

    // flyt til shipment service fil
    services: any[] = [
        {service_code: 'pod', service_name: 'Må sættes uden kvittering', locked: true}, // locked, can't be set from control
        {service_code: 'droppoint', service_name: 'Pakkeshop', carriers: ['9', '11'], locked: true}, // locked, can't be set from control
        {service_code: 'business', service_name: 'Erhvervlevering', locked: true}, // locked, can't be set from control
        {service_code: 'skip_sms', service_name: 'Ingen SMS', locked: true}, // locked, can't be set from control
     //   {service_code: 'skip_email', service_name: 'Ingen Email', locked: true}, // locked, can't be set from control
        {service_code: 'international', service_name: 'International', locked: true, carriers: ['11']}, // locked, can't be set from control
        {service_code: 'DOT1', service_name: 'DOT1', carriers: ['10']},
        {service_code: 'DOT2', service_name: 'DOT2', carriers: ['10']},
        {service_code: 'DOT3', service_name: 'DOT3', carriers: ['10']},
        {service_code: 'DFM_SG', service_name: 'Stykgods', carriers: ['10']},
        {service_code: 'LONG_3M', service_name: 'Lang 3-6m', carriers: ['10']},
        {service_code: 'LONG_6M', service_name: 'Lang 6-12m', carriers: ['10']},
        {service_code: 'CRANE_DELIVERY', service_name: 'Levering med kranbil', carriers: ['10']},
        {service_code: 'CRANE_UNLOAD', service_name: 'Aflæsning med kran', carriers: ['10']},
        {service_code: 'DFM_OE', service_name: 'Erhvervsbil', carriers: ['10']},
        {service_code: 'PHONE_NT', service_name: 'Ring inden levering', carriers: ['10']},
    ];

    carriers: any[] = [
        //    {id: '9', name: 'PostNord'},
        {id: '10', name: 'Danske Fragtmænd'},
        {id: '11', name: 'GLS'},
        {id: '907', name: 'Egen bil'},
        //     {id: '212', name: 'BFT'},
        {id: '777', name: 'Direkte levering'},
        {id: '888', name: 'Boxen'},
        {id: '999', name: 'Afhenter'},
    ];

    public saving = false;
    public deleting = false;
    public completing = false;
    public environment;
    public showDiagram = false;

    protected validServices: any[];
    protected activeShipmentPackagings: any[];
    protected readonly faShare = faShare;
    protected readonly faTrash = faTrash;
    protected hasValidationErrors: boolean;
    protected showBackButton: boolean;
    private returnTo: any;

    constructor(public shipmentsService: ShipmentsService,
                public lightbox: Lightbox,
                private sanitized: DomSanitizer,
                public ngbModal: NgbModal,
                public shipmentPackagesService: ShipmentPackagesService,
                private router: Router,
                private usersService: UsersService, public activatedRoute: ActivatedRoute
    ) {
        this.environment = environment;

    }

    ngOnInit() {

        const currentUrl = this.router.url;
        combineLatest([
            this.activatedRoute.queryParams,
            this.usersService.getCurrentUser(),
        ]).subscribe(([params, user]) => {
            if (params.return_to && params.return_to.startsWith('control')) {
                this.returnTo = params.return_to;
                this.showBackButton = true;
            } else {
                this.returnTo = null;
                this.showBackButton = false;
            }
        });

        this.calculateValidServices();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes._shipment) {
            this.calculateValidServices();
        }
    }


    calculateValidServices(carrier_code: any = this._shipment.carrier_code) {

        this.validServices = this.services.filter((service) => {
            if (!carrier_code) {
                return false;
            }
            if (!service.carriers) {
                return true;
            }
            if (service.carriers.find((item) => {
                if (item === carrier_code) {


                    // Only allow one DOTx option at a time
                    const dotServices = ['DOT1', 'DOT2', 'DOT3'];
                    if (dotServices.includes(service.service_code)) {
                        const hasDifferentDot = this._shipment.shipment_services.find((_) =>
                            dotServices.includes(_.service_code) && _.service_code !== service.service_code
                        );
                        if (hasDifferentDot) {
                            return false;
                        }
                    }


                    const dotServices2 = ['DFM_SG', 'LONG_6M', 'LONG_3M'];
                    if (dotServices2.includes(service.service_code)) {
                        const hasDifferentDot2 = this._shipment.shipment_services.find((_) =>
                            dotServices2.includes(_.service_code) && _.service_code !== service.service_code
                        );
                        if (hasDifferentDot2) {
                            return false;
                        }
                    }

                    return true;
                }
                return false;
            })) {
                return true;
            }
            return false;
        }).map((service) => {
            const check = this._shipment.shipment_services.find((item) => {
                return item.service_code === service.service_code
            });
            if (check) {
                service._selected = true;
            } else {
                service._selected = false;
            }

            return service;
        });

        // remove invalid services from this._shipment.shipment_services
        this._shipment.shipment_services = this._shipment.shipment_services.filter(service => this.validServices.find(validService => validService.service_code === service.service_code));

        this.isReturn = this._shipment.isReturnShipment();
        this.imageBase64 = this._shipment.barcode;
    }


    openImageLink(image_link: any) {
        this.album = [
            {
                src: image_link.preview_url,
                caption: image_link.title,
                thumb: image_link.preview_url
            }
        ];

        this.lightbox.open(this.album, 0);
    }

    open(shipmentEvent: ShipmentEvent) {
        const image = this.sanitized.bypassSecurityTrustResourceUrl('data:image/jpeg;base64, ' + shipmentEvent.image);

        this.album = [
            {
                src: image,
                caption: shipmentEvent.status_text,
                thumb: image
            }
        ];

        this.lightbox.open(this.album, 0);
    }

    editLocation() {
        const modalRef = this.ngbModal.open(ShipmentEditModalComponent, {size: 'xl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment = this._shipment;
        modalRef.componentInstance.showAddress = true;
        modalRef.componentInstance.saved = (result: Shipment) => {
            this._shipment = result
            this.shipmentsService.postShipmentChangedEvent(true);
        };
    }

    close(): void {
        this.lightbox.close();
    }

    save(retur: boolean = false): Observable<any> {
        this.saving = true;
        const data = {
            id: this._shipment.id,
            shipment_route_id: this._shipment.shipment_route_id,
            carrier_code: this._shipment.carrier_code,
            dropoff_time: this._shipment.dropoff_time,
            shipping_date: this._shipment.shipping_date,
            internal_comment: this._shipment.internal_comment,
            comments: this._shipment.comments,
            additional_reference: this._shipment.additional_reference,
            pickup_instructions: this._shipment.pickup_instructions,
            shipment_priority: this._shipment.shipment_priority,
            shipment_services: this._shipment.shipment_services,
            shipment_addresses: this._shipment.shipment_addresses,
            shipment_product_lines: this._shipment.shipment_product_lines,
            is_return_shipment: this._shipment.is_return_shipment,
        };

        return from(this.shipmentsService.updateShipmentPartial(this._shipment.id, data)).pipe(
            tap((_) => {
                console.log('shipment saved',_);
                this.shipmentsService.postShipmentChangedEvent(true);
                this.stuffChanged.emit(this._shipment);
                if (retur) {
                    switch (this.returnTo) {
                        case 'control':
                            this.router.navigateByUrl('/kontrol/shipment-control?scan=' + this._shipment.nota_number);
                            break
                    }
                } else {
                    this.calculateValidServices();
                }
                this.saving = false;
            }),
            finalize(() => {
                this.saving = false;
            })
        )
    }

    complete() {
        this.completing = true;
        this.shipmentsService.createShipmentEvent({
            foreign_key: this._shipment.id,
            model: 'Shipments',
            status_text: 'Leveret til kunden',
            shipment_status: 'complete',
            date: moment()
        }).then(response => {
            this.completing = false;
            this.stuffChanged.emit(this._shipment);
            this.shipmentsService.postShipmentChangedEvent(true);
        });
    }

    // events
    startCreateNewEvent() {
        const modalRef = this.ngbModal.open(ShipmentEventModalComponent, {size: 'sm'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment = this._shipment;
        modalRef.componentInstance.saved = (result: Shipment) => {
            this.shipmentsService.postShipmentChangedEvent(true);
        };
    }

    changePriority($event) {
        if (this._shipment.shipment_priority === 9999) {
            this._shipment.shipment_priority = null;
        } else {
            this._shipment.shipment_priority = 9999;
        }
    }

    flashShipment() {
        this.shipmentsService.flashShipment(this._shipment.id, []).then(() => {
            alert('shipment wil flash for 30 second')
        })
    }

    quickAction(shipment_status, is_notified: boolean = false) {
        const event = ShipmentEvent.fromJSON({
            foreign_key: this._shipment.id,
            model: 'Shipments',
            date: moment(),
            status_text: null,
            shipment_status: shipment_status,
            is_notified: is_notified
        });
        this.shipmentsService.createShipmentEvent(event).then(response => {
            this.shipmentsService.postShipmentChangedEvent(true);
        });
    }

    addPackage(isReturn:boolean): void {

        this.save().subscribe(() => {
            const modalRef = this.ngbModal.open(ShipmentPackageAddModalComponent, {size: 'lg'});
            modalRef.componentInstance.modal = modalRef;
            modalRef.componentInstance.activeShipment = this._shipment;
            modalRef.componentInstance.isReturn = isReturn;
            modalRef.componentInstance.saved = () => {
                this.shipmentsService.postShipmentChangedEvent(true);
                this.stuffChanged.emit(this._shipment);
            };
        })

    }

    openForwardModal(shipmentEvent: ShipmentEvent) {
        const modalRef = this.ngbModal.open(EventForwardModalComponent, {size: 'sm'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.event = shipmentEvent;
    }

    addProductLine() {
        const productLine = new ShipmentProductLine();
        this._shipment.shipment_product_lines.push(productLine);
        const modalRef = this.ngbModal.open(ShipmentProductLineModalComponent, {size: 'lg'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment_product_line = productLine;
        modalRef.componentInstance.shipment = this._shipment;
        modalRef.result.then((result) => {
            if (result) {
                this.stuffChanged.emit(true);
                this.shipmentsService.postShipmentChangedEvent(true);
            }
        });
    }


    changeService(newService) {
        if (newService._selected && newService._selected === true) {
            this._shipment.shipment_services = this._shipment.shipment_services.filter(
                s => s.service_code !== newService.service_code
            );
        } else {
            const existingService = this._shipment.shipment_services ? this._shipment.shipment_services.find(
                service => service.service_code === newService.service_code
            ) : null;

            if (!existingService) {
                const servce = new ShipmentService();
                servce.service_code = newService.service_code;
                servce.service_name = newService.service_name;
                this._shipment.shipment_services.push(servce);
            }
        }
        this.save().subscribe();
    }

    changeCarrier($event) {
        this._shipment.carrier_code = $event;
        this.calculateValidServices($event);
        this.save().subscribe();
    }

    protected deleteShipment() {
        this.shipmentsService.deleteShipment(this._shipment).then(response => {
            if (this.parentModal) {
                this.parentModal.close();
            } else {
                this.router.navigateByUrl('/kontrol/shipping-system-search?show_map=0');
            }
        })
    }

    protected fetchPrice(shipmentPackage) {
        this.shipmentPackagesService.fetchShipmentPackagePrice(shipmentPackage).subscribe(response => {
                if (response) {
                    shipmentPackage.price = response.price;
                    shipmentPackage.invoice_number = response.invoice_number;
                } else {
                    alert('Kunne ikke hente pris');
                }
            }
        )
    }

    protected deletePackage(shipmentPackage) {

        if (confirm('Er du sikker på du vil slette denne label ?')) {
            this.shipmentPackagesService.deleteShipmentPackage(shipmentPackage).subscribe(response => {
                if (response) {
                    this.stuffChanged.emit(true);
                    this.shipmentsService.postShipmentChangedEvent(true);
                } else {
                    alert('Kunne ikke slette pakke');
                }
            })
        }
    }

    protected copy(asReturn: boolean = false) {
        this.saving = true;
        this.shipmentsService.updateShipment(this._shipment).then(() => {
            return this.shipmentsService.copyShipment(this._shipment, asReturn);
        }).then(response => {
            if (this.parentModal) {
                this.parentModal.close();
            }
            this.saving = false;
            this.router.navigateByUrl('/shipment/' + response.id);
        });
    }

    protected readonly ShipmentsService = ShipmentsService;

    protected resetState() {
        if (confirm('Er du sikker på du vil nulstillle denne forsendelse ?')) {
            this.shipmentsService.resetShipment(this._shipment.id).then(response => {
                this.stuffChanged.emit(true);
                this.shipmentsService.postShipmentChangedEvent(true);
            });
        }
    }

    protected readonly faDollarSign = faDollarSign;
    protected readonly faMobile = faMobile;
    protected readonly faPhoneAlt = faPhoneAlt;
    protected readonly faMobileAlt = faMobileAlt;
}

export default ShipmentEditFormComponent
